export default __webpack_public_path__ + "static/media/experience.0f20c2d6.png";